import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.clickOutside = this.clickOutside.bind(this)
    if (this.element.open) this.addListener()
  }

  clickOutside(e) {
    if (this.element.contains(e.target)) return

    this.element.open = false
    this.removeListener()
  }

  disconnect() {
    this.removeListener()
  }

  onToggle(event) {
    const currentDetails = event.currentTarget

    if (!currentDetails.open) return

    this.addListener()
  }

  removeListener() {
    document.removeEventListener("click", this.clickOutside)
  }

  addListener() {
    document.addEventListener("click", this.clickOutside)
  }
}
